/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'logs-page';
const prefix = `${moduleName}.${componentName}`;

export const loadingMessageLabel = `${prefix}.loadingMessageLabel`;
export const graphLoadingMessageLabel = `${prefix}.graphLoadingMessageLabel`;
export const tableLoadingMessageLabel = `${prefix}.tableLoadingMessageLabel`;
export const timeoutMessageLabel = `${prefix}.timeoutMessageLabel`;
export const refreshLogsLabel = `${prefix}.refreshLogsLabel`;
export const errMessageLabel = `${prefix}.errMessageLabel`;
export const reloadPageLabel = `${prefix}.reloadPageLabel`;
export const legacyViewBannerDialog = `${prefix}.legacyViewBannerDialog`;
export const provideFeedbackLabel = `${prefix}.provideFeedbackLabel`;
export const learnMoreLink = `${prefix}.learnMoreLink`;

export const ENGLISH = {
    [loadingMessageLabel]: 'Please wait, logs are being retrieved.',
    [graphLoadingMessageLabel]: 'Please wait, graph is being retrieved.',
    [tableLoadingMessageLabel]: 'Please wait, log data are being retrieved.',
    [timeoutMessageLabel]: 'We were unable to fetch all the logs. Please reduce the timeframe or refresh logs.',
    [refreshLogsLabel]: 'Refresh Logs',
    [errMessageLabel]: 'An error occurred while loading logs. Please try again.',
    [reloadPageLabel]: 'Reload Page',
    [legacyViewBannerDialog]: 'Thanks for trying out the new logs view. To revert to legacy view please go to My Account settings.',
    [provideFeedbackLabel]: 'Provide Feedback',
    [learnMoreLink]: 'Learn More',
};
